import React from 'react';

import { Block } from '../common/Block.jsx';
import { EmptyPlaceholder } from '../layout/Builder.jsx';
import { Container as CellContainer } from '../common/Cell.jsx';
import Input from './Input.jsx';
import Name from '../common/Name.jsx';
import Token from '../common/Token.jsx';

function InventoryLineItemCellContainer(props) {
    const blockPropsHandler = (d) => {
        if (!d.type) {
            return;
        }
        switch (d.type.value) {
            case Name.Block.Cart.LineItem.Cell.InventoryLineItemQuantityInput:
                const handleInputProps = (_, inputProps) => {
                    inputProps.value = props.data && props.data.quantity;
                    inputProps.onBlur = (_, value) => props.onQuantityInputBlur && props.onQuantityInputBlur(props.id, value);
                    inputProps.onChange = (_, value) => props.onQuantityChange && props.onQuantityChange(props.id, value);
                }
                return { onInputProps: handleInputProps }
            case Name.Block.Cart.RemoveButton:
                return { onClick: () => props.onRemove && props.onRemove(props.id) }
            case Name.Block.Inventory.Cell.Image:
                return { transforms: 'c_fit' };
            case Name.Block.Inventory.Cell.Text:
                return { parseConditions: [props.data.quantity] };
        }
    }
    return <CellContainer {...props} blockPropsHandler={blockPropsHandler} type="inventoryLineItem" />
}

function PromoCodeLineItemCellContainer(props) {
    const blockPropsHandler = (d) => {
        if (!d.type) {
            return;
        }
        switch (d.type.value) {
            case Name.Block.Cart.RemoveButton:
                return { onClick: props.onRemove }
        }
    }
    return <CellContainer {...props} blockPropsHandler={blockPropsHandler} type="promoCodeLineItem" />
}

// region INVENTORY QUANTITY INPUT

function InventoryQuantityInputComponent(props) {
    if (!props.builder && !props.data.canAdjustQuantity) {
        return null;
    }
    return <Input.Component {...props} allowZero={false} type="numeric" />
}
const InventoryQuantityInput = { Component: InventoryQuantityInputComponent };

// region PROMO CODE META

function _PromoCodeMetaComponent(props) {
    let style;
    if (props.blockConfig && props.blockConfig.layout) {
        style = {};
        Block.mapStyleConfigProps(style, props.blockConfig.layout);
    }
    if (style && style.maxHeight) {
        style.overflow = 'hidden';
    }
    return (
        <div style={style}>
            {
                props.content != undefined &&
                <div className="cont--token" dangerouslySetInnerHTML={{ __html: props.content }} style={{ lineHeight: 1 }} />
            }
            {
                props.builder &&
                (props.content == undefined || props.content.length == 0) &&
                <EmptyPlaceholder />
            }
        </div>
    );
}
const PromoCodeMetaComponent = Token.withContentTokenParsing(_PromoCodeMetaComponent, {}, (props, keyword, options) => {
    const promoCode = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Description:
            if (promoCode.description && promoCode.description.length > 0) {
                replaceString = Token.getReplacementString(promoCode.description, options);
            }
            break;
        case Token.Discount:
            if (promoCode.amount && promoCode.amount.length > 0) {
                replaceString = Token.getReplacementString(promoCode.amount, options);
            }
            break;
        case Token.PromoCode:
            if (promoCode.code && promoCode.code.length > 0) {
                replaceString = Token.getReplacementString(promoCode.code, options);
            }
            break;
    }
    return replaceString;
});
const PromoCodeMetaTokens = () => {
    return [
        Token.getWrappedTokenConfig('Code', Token.PromoCode),
        Token.getWrappedTokenConfig('Description', Token.Description),
        Token.getWrappedTokenConfig('Discount', Token.Discount)
    ];
}
const PromoCodeMeta = { Component: PromoCodeMetaComponent, Tokens: PromoCodeMetaTokens };

export { InventoryLineItemCellContainer, InventoryQuantityInput, PromoCodeLineItemCellContainer, PromoCodeMeta }